import { faClone } from '@fortawesome/free-solid-svg-icons';

import Icon from './Icon';

const CloneIcon = ({ toolTipText = 'Clone' }) => (
  <Icon tooltip={toolTipText} iconObj={faClone} />
);

export default CloneIcon;